import { useEffect, useMemo } from 'react';
import { ResourceStore } from 'src/stores/ResourceStore/ResourceStore';

export const useLoadResources = (resourceStores: ResourceStore[]) => {
    useEffect(() => {
        resourceStores.forEach((resourceStore) => {
            resourceStore.load();
        });
    }, [resourceStores]);

    const isLoadingResources = useMemo(() => {
        return resourceStores.some(
            (resourceStore) => resourceStore.resourceLoader.isLoading,
        );
    }, [resourceStores]);

    return { isLoadingResources };
};
